module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "backdrop",
    attrs: {
      "id": "backdrop"
    },
    on: {
      "click": _vm.closeNav
    }
  }), _vm._v(" "), (_vm.backButtonOnLeft) ? _c('div', {
    staticClass: "c-button hb-menu-icon",
    attrs: {
      "id": "c-button--slide-left"
    },
    on: {
      "click": _vm.openNav
    }
  }) : _c('div', {
    staticClass: "c-button hb-menu-icon",
    staticStyle: {
      "position": "relative",
      "right": "40px"
    },
    attrs: {
      "id": "c-button--slide-left"
    },
    on: {
      "click": _vm.openNav
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "side-nav-main-menu"
  }, [_c('div', {
    staticClass: "sidenav",
    style: (("width:" + (_vm.menus.width) + "; left:-" + (_vm.menus.width) + ";" + (_vm.menus.style))),
    attrs: {
      "id": "mySidenav"
    }
  }, [(_vm.index < _vm.menus.items.length - 1) ? _vm._l((_vm.menus.items), function(menuItem, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "position": "relative"
      },
      style: (menuItem.style)
    }, [_c('div', {
      staticClass: "cursor-pointer brightness",
      attrs: {
        "id": menuItem.id
      },
      on: {
        "click": function($event) {
          _vm.hoverableAction(menuItem.hoverable)
        }
      }
    }, [_c('img', {
      staticClass: "menu-hover",
      attrs: {
        "src": menuItem.imageSrc
      },
      on: {
        "mouseover": function($event) {
          _vm.handleMouseOver(menuItem, $event)
        },
        "mouseout": function($event) {
          _vm.handleMouseOut(menuItem, $event)
        }
      }
    }), _vm._v(" "), (menuItem.audioControl === true) ? _c('hoverable-image', {
      staticClass: "audioControl",
      attrs: {
        "images": _vm.muteImages
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleAudioControl($event)
        }
      }
    }) : _vm._e()], 1), _vm._v(" "), (menuItem.subMenu) ? _c('span', {
      staticClass: "menu-arrow",
      on: {
        "click": function($event) {
          _vm.handleSubMenuClicked(menuItem, $event)
        }
      }
    }, [_c('img', {
      staticClass: "arrow-hover",
      attrs: {
        "src": _vm.menus.subMenuArrow.imageSrc
      }
    })]) : _vm._e()])
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "home-nav-btn cursor-pointer brightness",
    style: (_vm.menus.items[_vm.menus.items.length - 1].style),
    attrs: {
      "id": _vm.menus.items[_vm.menus.items.length - 1].id
    },
    on: {
      "click": function($event) {
        _vm.closeApp()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.menus.items[_vm.menus.items.length - 1].imageSrc
    },
    on: {
      "mouseover": function($event) {
        _vm.handleMouseOver(_vm.menus.items[_vm.menus.items.length - 1], $event)
      },
      "mouseout": function($event) {
        _vm.handleMouseOut(_vm.menus.items[_vm.menus.items.length - 1], $event)
      }
    }
  })])], 2), _vm._v(" "), _vm._l((_vm.subMenus), function(subMenu) {
    return _c('div', {
      key: subMenu,
      staticClass: "sidesubnav brightness",
      style: (("width: " + (subMenu.width) + "; left: -" + (subMenu.width))),
      attrs: {
        "id": subMenu.id
      }
    }, [_c('img', {
      staticClass: "menu-hover",
      attrs: {
        "src": subMenu.imageSrc
      }
    }), _vm._v(" "), _vm._l((subMenu.items), function(menuItem) {
      return _c('div', {
        key: menuItem,
        staticClass: "subMenuItem",
        class: {
          'disabled': menuItem.disabled, 'debug': menuItem.debug || _vm.debug
        },
        style: (menuItem.style),
        on: {
          "click": function($event) {
            _vm.hoverableAction(menuItem.hoverable)
          }
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(menuItem.Text)
        }
      })])
    })], 2)
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c1db5dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheSideMenu.vue
// module id = 222
// module chunks = 1